module.exports = __webpack_public_path__ + "static/fonts/FedraSerifB-BoldItalic.929dd6f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/font/FedraSerifB-BoldItalic.otf
// module id = 838
// module chunks = 3 4 5 10